<template>
  <div class="table-wrap">
    <md-card>
      <md-card-header class="table-container">
        <md-card-header-text>
          <p class="md-title">Resumen mensual</p>
        </md-card-header-text>
        <md-card-header-text>
          <md-field class="custom-field-search-table">
            <md-icon>search</md-icon>
            <label>Burcar</label>
            <md-input v-model="search"></md-input>
          </md-field>
        </md-card-header-text>
      </md-card-header>
      <template v-if="tableHeaders.length > 0">
        <div class="table-card" id="js-table-data" @scroll="scrollTable">
          <div class="table-card__header">
            <div class="table-card__header-cell">
              <md-checkbox v-model="idAll" @change="selectAll"></md-checkbox>
            </div>
            <div
              class="table-card__header-cell"
              :class="{
                'table-card__header-cell--big': headcell.key === 'employee',
                'table-card__header-cell--biggest': headcell.key === 'dayReport',
              }"
              v-for="headcell in tableHeaders"
              :key="`tablecell-${headcell.key}`"
            >
              <span v-if="!headcell.subheader">
                {{ headcell.label }}
              </span>
              <div class="table-card__header-cell__inner" v-else>
                <div class="table-card__header-cell__inner--superior">
                  <p>{{ headcell.label }}</p>
                </div>
                <div class="table-card__header-cell__inner--inferior">
                  <div
                    v-for="(subheadcell, key) in headcell.subheader"
                    :key="`tablecell-${headcell.key}-sub-${key}`"
                    class="table-card__header-cell__inner--inferior__content"
                  >
                    {{ subheadcell }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="table-card__body">
            <div
              class="table-card__body-row"
              v-for="(row, $index) in source"
              :key="`row-${$index}`"
              @dblclick="viewSummary(row.id)"
            >
              <div
                class="table-card__body-cell"
                :class="{
                  'table-card__body-cell--big': key === 'employee',
                  'table-card__body-cell--biggest': key === 'dayReport',
                  'table-card__body-cell--center': key === 'id',
                  'table-card__body-cell--none': ['isValidated','validatedTo'].includes(key),
                }"
                v-for="(field, key) in row"
                :key="`row-${$index}-field-${key}`"
              >
                <template>
                  <span v-if="isNotObject(field)">
                    <template v-if="key === 'id'">
                      <md-checkbox :value="field" v-model="ids"></md-checkbox>
                    </template>
                    <template v-else-if="!['isValidated','validatedTo'].includes(key)">
                      {{ field | currency }}
                      <svg v-if="key === 'employee'" v-show="row.isValidated" :aria-describedby="row.validatedTo" width="16" height="16" viewBox="0 0 24 24"><title>{{row.validatedTo}}</title><path fill="#97c2c9" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4ZM12 22q-2.075 0-3.9-.788q-1.825-.787-3.175-2.137q-1.35-1.35-2.137-3.175Q2 14.075 2 12t.788-3.9q.787-1.825 2.137-3.175q1.35-1.35 3.175-2.138Q9.925 2 12 2t3.9.787q1.825.788 3.175 2.138q1.35 1.35 2.137 3.175Q22 9.925 22 12t-.788 3.9q-.787 1.825-2.137 3.175q-1.35 1.35-3.175 2.137Q14.075 22 12 22Zm0-2q3.35 0 5.675-2.325Q20 15.35 20 12q0-3.35-2.325-5.675Q15.35 4 12 4Q8.65 4 6.325 6.325Q4 8.65 4 12q0 3.35 2.325 5.675Q8.65 20 12 20Zm0-8Z"/></svg>
                    </template>
                  </span>
                  <div class="table-card__body-cell__inner" v-else>
                    <div class="table-card__body-cell__inner--inferior">
                      <div
                        v-for="(subfield, $key) in field"
                        :key="`tablecell-${key}-sub-${$key}`"
                        class="table-card__body-cell__inner--inferior__content"
                      >
                        {{ subfield > 0 ? `${subfield}` : "-" }}
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="table-card table-card--total" id="js-table-total">
          <div class="table-card__body-row">
            <div class="table-card__body-cell"></div>
            <div
              class="table-card__body-cell"
              :class="{
                'table-card__body-cell--big': key === 'employee',
                'table-card__body-cell--biggest': key === 'dayReport',
              }"
              v-for="(field, key) in sumatory"
              :key="`row-field-${key}`"
            >
              <span v-if="isNotObject(field)">
                {{ field | currency }}
              </span>
              <div class="table-card__body-cell__inner" v-else>
                <div class="table-card__body-cell__inner--inferior">
                  <div
                    v-for="(subfield, $key) in field"
                    :key="`tablecell-${key}-sub-${$key}`"
                    class="table-card__body-cell__inner--inferior__content"
                  >
                    {{ subfield }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="table-card--empty" v-else>
        <h3>No hay datos</h3>
      </div>
      <!-- {{ getTotal() }} -->
    </md-card>
  </div>
</template>

<script>
// import VGrid from "@revolist/vue-datagrid";
export default {
  props: {
    date: String,
    downloadDone: Boolean,
  },
  name: "ResumeMonthly",
  components: {
    // VGrid,
  },
  data() {
    return {
      search: null,
      searched: [],
      aux: null,
      sumatory: {},
      ids: [],
      idAll: false,
    };
  },
  created() {
    // this.$emit("loading", true);
    // this.$store.dispatch("summaryMonth", {
    //   id: this.$localStorage.get("businessID"),
    //   date: new Date().toISOString(),
    // }).then(res => {
    //   if(res.status){
    //     console.log("get data monthly");
    //   }
    //   this.$store.commit("SET_DATE_CALC", new Date());
    //   this.$emit("loading", false);
    // }).catch(err =>{
    //   console.error(err);
    //   throw err;
    // } );
  },
  computed: {
    summary: {
      get() {
        this.$store.watch(
          (state, getters) => getters.summaryByMonthData,
          (newValue, oldValue) => {
            this.searched = newValue;
            return this.$store.getters.summaryByMonthData;
          }
        );
        return this.$store.getters.summaryByMonthData;
      },
      set(val) {
        this.$store.commit("SET_SUMMARY_MONTHDATA", val);
      },
    },
    tableHeaders() {
      return this.$store.getters.summaryByMonthlyHeaders.filter(
        (item) => !["extraHours", "mobility"].includes(item.key)
      );
    },
    source() {
      return !this.search
        ? this.$store.getters.summaryByMonthData.map((it) => {
            return {
              id: it.employee.id,
              employee: it.employee.fullName,
              grossSalary: it.grossSalary,
              daysInMonth: `${it.daysInMonth}d`,
              workedDays: `${it.workedDays}d`,
              salaryByMonth: it.salaryByMonth,
              familyAssignment: it.familyAssignment,
              vacations: it.vacationSalary,
              commissions: it.commissions,
              bonuses: it.bonuses,
              gratifications: it.gratification,
              extraGratifications: it.extraGratifications,
              cts: it.ctsRIA,
              subTotalPositive: it.subTotalPositive,
              "resume5ta.month": it.resume5taMonth,
              "pensionCalc.mandatoryContribution": it.pensionCalc.mandatoryContribution,
              "pensionCalc.secure": it.pensionCalc.secure,
              "pensionCalc.commission": it.pensionCalc.commission,
              "pensionCalc.onp": it.pensionCalc.onp,
              deductions: it.deductions,
              advancePayment: it.advancePayment,
              loans: it.loans,
              foodVoucher: it.foodVoucher,
              // foodVoucher: it.foodVoucher,
              // deductions: it.totalDiscounts,
              subTotalNegative: it.subTotalNegative,
              totalToPay: it.totalToPay,
              esSalud: it.esSalud,
              eps: it.eps,
              concept0803: it.concept0803,
              dayReport: this.dayReportSummary(it.dayReport),
              isValidated: new Date(new Date(this.date).setMonth(new Date(this.date).getMonth() - 1)) <= new Date(it.validatedTo),
              validatedTo: `Validado el ${new Date(it.validatedTo).toLocaleDateString()}`
            };
          })
        : this.$store.getters.summaryByMonthData
            .filter((sum) =>
              sum.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
            )
            .map((it) => {
              return {
                id: it.employee.id,
                employee: it.employee.fullName.toUpperCase(),
                grossSalary: it.grossSalary,
                daysInMonth: `${it.daysInMonth}d`,
                workedDays: `${it.workedDays}d`,
                salaryByMonth: it.salaryByMonth,
                familyAssignment: it.familyAssignment,
                vacations: it.vacationSalary,
                commissions: it.commissions,
                bonuses: it.bonuses,
                gratifications: it.gratification,
                extraGratifications: it.extraGratifications,
                cts: it.resumeCts.ctsMonth,
                "resume5ta.month": it.resume5taMonth,
                "pensionCalc.mandatoryContribution": it.pensionCalc.mandatoryContribution,
                "pensionCalc.secure": it.pensionCalc.secure,
                "pensionCalc.commission": it.pensionCalc.commission,
                "pensionCalc.onp": it.pensionCalc.onp,
                deductions: it.deductions,
                advancePayment: it.advancePayment,
                loans: it.loans,
                // foodVoucher: it.foodVoucher,
                totalToPay: it.totalToPay,
                esSalud: it.esSalud,
                eps: it.eps,
                concept0803: it.concept0803,
                dayReport: this.dayReportSummary(it.dayReport),
              };
            });
    },
    dataTable() {
      return [this.tableHeaders, ...this.source];
    },
    searchedComp: {
      get() {
        if (!this.searched.length && !this.search) {
          this.searched = this.summary;
        }
        return this.searched;
      },
      set(val) {
        this.searched = val;
      },
    },
  },
  methods: {
    searchOnTable() {
      if (this.search) {
        this.searched = this.summary.filter((item) =>
          item.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
        )
          ? this.summary.filter((item) =>
              item.employee.fullName.toLowerCase().includes(this.search.toLowerCase())
            )
          : [];
      } else {
        this.searched = this.summary;
      }
    },
    viewSummary(id) {
      let item = this.source.find((it) => it.id === id);
      this.$store.commit("SET_CURRENT_SUMMARY_EMPLOYEE", `${item.employee}`);
      window.localStorage.setItem("currentSummaryEmployee", `${item.employee}`);
      this.$router.push({
        name: "countingPages",
        params: {
          id: item.id,
          name: `${item.employee}`,
          date: new Date(this.date).toISOString(),
        },
      });
    },
    dayReportSummary({
      absence,
      assistance,
      excusedAbsence,
      extraHours25,
      extraHours35,
      medicalBreak,
      medicalBreakSubsidized,
      vacation,
    }) {
      return {
        absence: absence,
        assistance: assistance,
        excusedAbsence: excusedAbsence,
        extraHours25: extraHours25,
        extraHours35: extraHours35,
        medicalBreak: medicalBreak,
        medicalBreakSubsidized: medicalBreakSubsidized,
        vacation: vacation,
      };
    },
    isNotObject(value) {
      return typeof value !== "object";
    },
    getTotal() {
      this.sumatory = {
        employee: "TOTAL",
        grossSalary: 0,
        daysInMonth: `-`,
        workedDays: `-`,
        salaryByMonth: 0,
        familyAssignment: 0,
        vacations: 0,
        commissions: 0,
        bonuses: 0,
        gratifications: 0,
        extraGratifications: 0,
        cts: 0,
        subTotalPositive: 0,
        "resume5ta.month": 0,
        "pensionCalc.mandatoryContribution": 0,
        "pensionCalc.secure": 0,
        "pensionCalc.commission": 0,
        "pensionCalc.onp": 0,
        deductions: 0,
        advancePayment: 0,
        loans: 0,
        foodVoucher: 0,
        subTotalNegative: 0,
        totalToPay: 0,
        esSalud: 0,
        eps: 0,
        concept0803: 0,
        dayReport: {
          absence: 0,
          assistance: 0,
          excusedAbsence: 0,
          extraHours25: 0,
          extraHours35: 0,
          medicalBreak: 0,
          medicalBreakSubsidized: 0,
          vacation: 0,
        },
      };
      for (let indice = 0; indice < this.source.length; indice++) {
        this.sumatory.grossSalary =
          this.sumatory.grossSalary + this.source[indice].grossSalary;
        this.sumatory.salaryByMonth =
          this.sumatory.salaryByMonth + this.source[indice].salaryByMonth;
        this.sumatory.familyAssignment =
          this.sumatory.familyAssignment + this.source[indice].familyAssignment;
        this.sumatory.vacations = this.sumatory.vacations + this.source[indice].vacations;
        this.sumatory.commissions =
          this.sumatory.commissions + this.source[indice].commissions;
        this.sumatory.bonuses = this.sumatory.bonuses + this.source[indice].bonuses;
        this.sumatory.gratifications =
          this.sumatory.gratifications + this.source[indice].gratifications;
        this.sumatory.extraGratifications =
          this.sumatory.extraGratifications + this.source[indice].extraGratifications;
        this.sumatory.cts = this.sumatory.cts + this.source[indice].cts;
        this.sumatory.subTotalPositive =
          this.sumatory.subTotalPositive + this.source[indice].subTotalPositive;
        this.sumatory["resume5ta.month"] =
          this.sumatory["resume5ta.month"] + this.source[indice]["resume5ta.month"];
        this.sumatory["pensionCalc.mandatoryContribution"] =
          this.sumatory["pensionCalc.mandatoryContribution"] +
          this.source[indice]["pensionCalc.mandatoryContribution"];
        this.sumatory["pensionCalc.secure"] =
          this.sumatory["pensionCalc.secure"] + this.source[indice]["pensionCalc.secure"];
        this.sumatory["pensionCalc.commission"] =
          this.sumatory["pensionCalc.commission"] +
          this.source[indice]["pensionCalc.commission"];
        this.sumatory["pensionCalc.onp"] =
          this.sumatory["pensionCalc.onp"] + this.source[indice]["pensionCalc.onp"];
        this.sumatory.deductions =
          this.sumatory.deductions + this.source[indice].deductions;
        this.sumatory.advancePayment =
          this.sumatory.advancePayment + this.source[indice].advancePayment;
        this.sumatory.loans = this.sumatory.loans + this.source[indice].loans;
        this.sumatory.foodVoucher =
          this.sumatory.foodVoucher + this.source[indice].foodVoucher;
        this.sumatory.subTotalNegative =
          this.sumatory.subTotalNegative + this.source[indice].subTotalNegative;
        this.sumatory.totalToPay =
          this.sumatory.totalToPay + this.source[indice].totalToPay;
        this.sumatory.esSalud = this.sumatory.esSalud + this.source[indice].esSalud;
        this.sumatory.eps = this.sumatory.eps + this.source[indice].eps;
        this.sumatory.concept0803 = this.sumatory.concept0803 + this.source[indice].concept0803;
        this.sumatory.dayReport.absence =
          this.sumatory.dayReport.absence + this.source[indice].dayReport.absence;
        this.sumatory.dayReport.assistance =
          this.sumatory.dayReport.assistance + this.source[indice].dayReport.assistance;
        this.sumatory.dayReport.excusedAbsence =
          this.sumatory.dayReport.excusedAbsence +
          this.source[indice].dayReport.excusedAbsence;
        this.sumatory.dayReport.extraHours25 =
          this.sumatory.dayReport.extraHours25 +
          this.source[indice].dayReport.extraHours25;
        this.sumatory.dayReport.extraHours35 =
          this.sumatory.dayReport.extraHours35 +
          this.source[indice].dayReport.extraHours35;
        this.sumatory.dayReport.medicalBreak =
          this.sumatory.dayReport.medicalBreak +
          this.source[indice].dayReport.medicalBreak;
        this.sumatory.dayReport.medicalBreakSubsidized =
          this.sumatory.dayReport.medicalBreakSubsidized +
          this.source[indice].dayReport.medicalBreakSubsidized;
        this.sumatory.dayReport.vacation =
          this.sumatory.dayReport.vacation + this.source[indice].dayReport.vacation;
      }
    },
    scrollTable() {
      let tableTotal = document.querySelector("#js-table-total");
      let tableData = document.querySelector("#js-table-data");
      tableTotal.scrollLeft = tableData.scrollLeft;
    },
    selectAll($event) {
      if ($event) {
        this.ids = this.source.map((item) => item.id);
      } else {
        this.ids = [];
      }
    },
    getValidation(row) {
      return row.isValidated
    }
  },
  watch: {
    source() {
      this.getTotal();
    },
    ids(n) {
      this.$emit("checked-employees", n);
    },
    downloadDone(n) {
      if (n) {
        this.ids = [];
      }
    },
  },
};
</script>

<style lang="scss">
.nowrap {
  white-space: nowrap;
}
.fullname {
  min-width: 155px;
}
.cell-report-day {
  min-width: 200px;
  .absence {
    color: #ef476f;
  }
  .assistance {
    color: #2cc0d5;
  }
  .vacation {
    color: #93c737;
  }
  .medical {
    color: #f9de5c;
  }
  .medical-sub {
    color: #d8ff00;
  }
  .extrahours {
    color: #7b1fa2;
  }
  .absence-ex {
    color: #d939cd;
  }
}
.table-wrap {
  // height: calc(100vh - 190px);
  // max-height: 500px;
  height: 200%;
  // overflow-y: scroll;
}
// revo-grid {
//   height: 100%;
// }
// revogr-viewport .main-viewport {
//   height: 100%;
// }
.table-card {
  width: 100%;
  height: 100%;
  max-height: 490px;
  position: relative;
  overflow: auto;
  &--total {
    overflow: hidden;
  }
  &__header {
    background-color: #ffffff;
    position: sticky;
    top: 0;
    // width: 100%;
    z-index: 20;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 3710px;
    box-shadow: 0px 3px 5px 0px rgba($color: #999999, $alpha: 0.7);
    &-cell {
      background-color: #ffffff;
      padding: 1rem 0.5rem;
      margin: 0 5px;
      font-weight: bold;
      font-size: 12px;
      flex: 0 0 105px;
      height: 90.59px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: right;
      .md-checkbox {
        margin: 0px !important;
      }
      &--big {
        min-width: 250px;
        text-align: left;
        position: sticky;
        justify-content: flex-start;
        left: 0;
        z-index: 10;
        box-shadow: 1px 0px 1px 0px rgba($color: #999999, $alpha: 0.4);
      }
      &--biggest {
        min-width: 800px;
        background-color: rgba($color: #2cc0d5, $alpha: 0.4);
      }
      &__inner {
        width: 100%;
        &--superior {
          width: 100%;
          p {
            text-align: center;
          }
        }
        &--inferior {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          &__content {
            min-width: 97px;
            max-width: 97px;
            font-size: 12px;
            padding: 0 0.5rem;
          }
        }
      }
    }
  }
  &__body {
    // padding: 1rem;
    width: fit-content;
    &-row {
      position: relative;
      width: 3710px;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      border-bottom: thin solid rgba($color: #999999, $alpha: 0.4);
    }
    &-cell {
      background-color: #ffffff;
      padding: 1rem 0.5rem;
      margin: 0 5px;
      font-weight: normal;
      font-size: 14px;
      flex: 0 0 105px;
      text-align: right;
      &--center {
        text-align: center;
        .md-checkbox {
          margin: 0px !important;
        }
      }
      &--none {
        display: none;
      }
      &--big {
        position: sticky;
        left: 0;
        text-align: left;
        z-index: 10;
        min-width: 250px;
        box-shadow: 1px 0px 1px 0px rgba($color: #999999, $alpha: 0.4);
      }
      &--biggest {
        min-width: 800px;
        background-color: rgba($color: #2cc0d5, $alpha: 0.4);
      }
      &__inner {
        width: 100%;
        &--superior {
          width: 100%;
          p {
            text-align: center;
          }
        }
        &--inferior {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          &__content {
            width: 97px;
            font-size: 12px;
            padding: 0 0.5rem;
            text-align: center;
          }
        }
      }
    }
  }
  &--empty {
    padding: 5rem;
    h3 {
      text-align: center;
    }
  }
}
.table-container {
  .md-card-header-text {
    .custom-field-search-table {
      margin: 0px;
    }
  }
}
</style>
